import { cn } from '@/lib/utils'

interface TapeNoteProps {
  children: React.ReactNode
  variant: 'error' | 'success' | 'primary'
  rotation?: number
  className?: string
}

const VARIANT_STYLES: Record<TapeNoteProps['variant'], string> = {
  error: 'bg-error-light border-error-border',
  success: 'bg-success-light border-success-border',
  primary: 'bg-primary-light border-primary-border',
}

export function TapeNote({
  children,
  variant,
  rotation = 0,
  className,
}: TapeNoteProps) {
  return (
    <div
      className={cn(
        'relative rounded-2xl border px-5 pt-7 pb-5',
        VARIANT_STYLES[variant],
        className
      )}
      style={
        rotation !== 0 ? { transform: `rotate(${rotation}deg)` } : undefined
      }
    >
      {/* Cellotape strip — semi-transparent with shine */}
      <div
        className="absolute -top-1.5 left-1/2 -translate-x-1/2 -rotate-1"
        aria-hidden="true"
      >
        <div
          className="relative h-4 w-16 overflow-hidden rounded-sm"
          style={{
            background:
              'linear-gradient(180deg, rgba(200,200,180,0.55) 0%, rgba(200,200,180,0.35) 100%)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          }}
        >
          {/* Shine streak */}
          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(105deg, transparent 30%, rgba(255,255,255,0.5) 45%, rgba(255,255,255,0.3) 55%, transparent 70%)',
            }}
          />
        </div>
      </div>

      <div className="text-ink font-[family-name:var(--font-handwritten)] text-lg leading-relaxed">
        {children}
      </div>
    </div>
  )
}
